import * as React from "react";
import type { SVGProps } from "react";
const ConsultingAgency = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_151)">
      <path
        fill="currentColor"
        d="M9.3333 4.3333V6H16V4.3333A.3343.3343 0 0 0 15.6667 4h-6a.3343.3343 0 0 0-.3334.3333M7.3333 6V4.3333C7.3333 3.0458 8.3792 2 9.6667 2h6C16.9542 2 18 3.0458 18 4.3333V22H7.3333zM4.6667 6H6v16H4.6667C3.1958 22 2 20.8042 2 19.3333V8.6667C2 7.1958 3.1958 6 4.6667 6m16 16h-1.3334V6h1.3334c1.4708 0 2.6666 1.1958 2.6666 2.6667v10.6666c0 1.4709-1.1958 2.6667-2.6666 2.6667"
      />
    </g>
    <defs>
      <clipPath id="clip0_4355_151">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default ConsultingAgency;
